require('./openstep/index');
import { createAppWrap } from '../../create_app_wrap';

const view = '[data-view="official"]';
const init = () => {
    /**
     * Vueオブジェクト
     * @type {Vue|any}
     */
    createAppWrap({
        el: view,
        /**
         * データ群
         */
        data() {
            return {};
        },
        /**
         * ミックスインオブジェクト
         */
        mixins: [],
        /**
         * インスタンス生成時に実行される処理
         */
        created: function () {},
        /**
         * 算出プロパティ
         */
        computed: {},
        /**
         * 各種メソッド
         */
        methods: {},
    });
};

if (document.querySelector(view)) {
    init();
}

